if (!window.customElements.get('configurator-section')) {
  class Configurator extends HTMLElement {
    constructor() {
      super();

      this.state = {
        supplyDuration: null,
        type: null,
        price: null,
        neutralizer: null,
        mainProduct: {
          title: null,
          handle: null,
          id: null,
          variantId: null,
          sku:null
        },
        flavourProduct: {
          title: null,
          handle: null,
          id: null,
          variantId: null,
          url: null,
          selected: false
        },
        addonProducts: [],
        binderProducts: [],
        retailProducts: [],
        listName: null,
        labelName: null,
        clientName: null,
        emailAddress: null,
        allergyInformation: null,
        consultation:this.querySelector('[data-configurator-consultation]').value
      };

      this.productData = JSON.parse(this.getAttribute('data-product-json'));
      this.navLinks = this.querySelectorAll('[data-configurator-nav-link]');
      this.steps = this.querySelectorAll('[data-configurator-step]');
      this.backButtons = this.querySelectorAll('[data-configurator-back]');
      this.saveProtocolButtons = this.querySelectorAll('[data-configurator-save-protocol]');
      this.primarySaveProtocolButton = this.querySelector('[data-configurator-primary-save-protocol]');
      this.continueButtons = this.querySelectorAll('[data-configurator-continue]');
      this.summaries = this.querySelectorAll('[data-configurator-summary]');
      this.supplyDurationOptions = this.querySelectorAll('[data-supply-duration-option]');
      this.typeOptions = this.querySelectorAll('[data-configurator-type-option]');
      this.neutralizerSelect = this.querySelector('[data-configurator-neutralizer-select]');
      this.complimentaryFlavourSelect = this.querySelector('[data-configurator-complimentary-flavour-select]');
      this.mandatoryAddonSelects = this.querySelectorAll('[data-configurator-mandatory-addon-select]');
      this.addonProductCheckboxes = this.querySelectorAll('[data-configurator-addon-product-checkbox]');
      this.addonProducts = this.querySelectorAll('[data-configurator-addon-product]');
      this.addonVariantSelects = this.querySelectorAll('[data-configurator-addon-select]');
      this.quantityInputs = this.querySelectorAll('[data-configurator-quantity-input]');
      this.quantityButtons = this.querySelectorAll('[data-configurator-quantity-button]');
      this.labelNameInput = this.querySelector('[data-configurator-label-name]');
      this.clientNameSelect = this.querySelector('[data-configurator-client-name]');
      this.allergyInformationTextarea = this.querySelector('[data-configurator-allergy-information]');
      this.confirmation = this.querySelector('[data-configurator-confirmation]');
      this.consultation = this.querySelector('[data-configurator-consultation]');
      this.saveButton = this.querySelector('[data-configurator-save]');
      this.summaryImageText = this.querySelector('[data-configurator-summary-image-text]');
    }

    connectedCallback() {
      this.wishlistPlusInit();

      this.supplyDurationOptions.forEach((option) => option.addEventListener('click', () => this.selectSupplyDuration(option)));
      this.typeOptions.forEach((option) => option.addEventListener('click', (event) => this.selectType(option, event.target)));
      this.neutralizerSelect.addEventListener('change', () => this.updateNeutralizerInfo());
      this.complimentaryFlavourSelect.addEventListener('change', () => this.updateComplimentaryFlavourInfo());
      this.mandatoryAddonSelects.forEach((select) => select.addEventListener('change', () => this.updateMandatoryAddonInfo(select)));
      this.addonProductCheckboxes.forEach((checkbox) => checkbox.addEventListener('click', (event) => this.toggleAddon(checkbox, event.target)));
      this.addonVariantSelects.forEach((select) => select.addEventListener('change', () => this.updateAddonState()));
      this.quantityInputs.forEach((quantityInput) => quantityInput.addEventListener('change', () => this.updateProductState(quantityInput)));
      this.allergyInformationTextarea.addEventListener('change', () => this.state.allergyInformation = this.allergyInformationTextarea.value);
      this.confirmation.addEventListener('change', () => this.toggleConfirmation());
      this.consultation.addEventListener('change',() => {
        this.state.consultation = this.consultation.value;
        if (this.labelNameInput.value && this.confirmation && this.clientNameSelect.value && this.state.consultation != '') {
          this.primarySaveProtocolButton.toggleAttribute('disabled', !this.state.confirmation);
        } else {
          this.primarySaveProtocolButton.setAttribute('disabled', true);
        } 
      });
      this.saveProtocolButtons.forEach((button) => button.addEventListener('click', () => this.updateSavePopupInput()));

      this.navLinks.forEach((navLink) => {
        navLink.addEventListener('click', () => {
          if (navLink.classList.contains('disabled')) { return; }
          this.switchSteps(navLink.getAttribute('data-step'));
        });
      });

      this.backButtons.forEach((button) => button.addEventListener('click', () => {
        const targetStep = button.getAttribute('data-target-step');
       this.switchSteps(targetStep)
      }));

      this.continueButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const targetStep = button.getAttribute('data-target-step');
          this.switchSteps(targetStep);
        });
      });

      this.addonProducts.forEach((product) => product.addEventListener('click', (event) => {
        if (!event.target.hasAttribute('data-variant-map') || !product.classList.contains('disabled')) { return; }
        product.querySelector('[data-configurator-addon-product-checkbox]')?.click();
      }));

      this.quantityButtons.forEach((quantityButton) => {
        quantityButton.addEventListener('click', () => {
          const input = quantityButton.closest('.quantity-selector').querySelector('input');
          if (!input) { return; }
          input.dispatchEvent(new Event('change'));
        });
      });

      this.labelNameInput.addEventListener('keyup', () => {
        this.state.labelName = this.labelNameInput.value;
        this.summaryImageText.innerText = this.labelNameInput.value;

        const lengthValidation = this.labelNameInput.value.trim().length > 1;

        if (lengthValidation && this.confirmation && this.clientNameSelect.value && this.state.consultation != '') {
          this.primarySaveProtocolButton.toggleAttribute('disabled', !this.state.confirmation);
        } else {
          this.primarySaveProtocolButton.setAttribute('disabled', true);
        }
      });

      this.clientNameSelect.addEventListener('change', () => {
        this.state.clientName = this.clientNameSelect.value;
        this.state.emailAddress = this.clientNameSelect.options[this.clientNameSelect.selectedIndex]?.getAttribute('data-email-address');

        const lengthValidation = this.labelNameInput.value.trim().length > 1;

        if (lengthValidation && this.confirmation && this.clientNameSelect.value && this.state.consultation != '') {
          this.primarySaveProtocolButton.toggleAttribute('disabled', !this.state.confirmation);
        } else {
          this.primarySaveProtocolButton.setAttribute('disabled', true);
        }
      });

      document.body.addEventListener('click', (event) => {
        if (event.target.hasAttribute('data-configurator-save-popup-atc')) {
          this.addToCart();
        }

        if (event.target.hasAttribute('data-configurator-save-popup-submit')) {
          this.saveProtocol();
        }
      });

      document.addEventListener('buildFromEditLink', (event) => {
        this.buildFromEditLink(event.detail);
      });

      // Trigger changes will be lost dialog if user has not completed the entire flow
      window.onbeforeunload = () => {
        if (!this.primarySaveProtocolButton.hasAttribute('disabled')) { return; }
        return 'Changes will be lost';
      }
    }

    /**
     * Select supply duration
     * @param {Element} option - The option that gets clicked
     */
    selectSupplyDuration(option) {
      const selectedTypeOption = Array.from(this.typeOptions).find((option) => option.querySelector('input').checked);
      const startingPrice = selectedTypeOption ? selectedTypeOption.querySelector('[data-configurator-variant-price]').innerText : '';
      const continueButton = option.closest('[data-configurator-step]').querySelector('[data-configurator-continue]');

      continueButton.removeAttribute('disabled');

      this.state.supplyDuration = option.getAttribute('data-value');
      this.state.price = startingPrice;
      this.updateMainProductPricing();
      this.updateAddonSelects();
      this.updateMandatoryAddonSelects();
      this.updateMainProductIds();
      this.buildSummary();
    }

    /**
     * Select type
     * @param {Element} option - The option that gets clicked
     * @param {Event target} eventTarget - The event target
     */
    selectType(option, eventTarget) {
      if (eventTarget.hasAttribute('data-ingredients-popup-trigger')) { return; }

      const type = option.getAttribute('data-value').split(' - ')[0];
      const price = option.querySelector('[data-configurator-variant-price]')?.innerText;
      const continueButton = option.closest('[data-configurator-step]').querySelector('[data-configurator-continue]');

      continueButton.setAttribute('disabled', true);

      this.state.type = type;
      this.state.price = price;

      this.updateTypeSelects();
      this.updateNeutralizerInfo();
      this.updateComplimentaryFlavourInfo();
      this.updateMainProductIds();
      this.buildSummary();
      this.typeStepValidation();
    }

    /**
     * Validate the type step and ensure the user has selected additional options if this.state.type === 'Powder'
     */
    typeStepValidation() {
      const typeStep = Array.from(this.steps).find((step) => step.closest('.configurator__step--powder_or_capsules'));
      const typeSelects = this.querySelectorAll('[data-configurator-type-select] select');
      const unselectedOption = Array.from(typeSelects).filter((select) => select.value === '');
      const unselectedMandatoryAddons = Array.from(this.mandatoryAddonSelects).filter((select) => select.value === '');

      if (this.state.type === 'Powder' && unselectedOption.length || this.mandatoryAddonSelects && unselectedMandatoryAddons.length) { return; }

      const continueButton = typeStep?.querySelector('[data-configurator-continue]');

      if (continueButton) {
        continueButton.removeAttribute('disabled');
      }
    }

    /**
     * Toggle addon disabled state
     * @param {Element} checkbox - The checkbox that gets clicked
     * @param {Event target} eventTarget - The event target
     */
    toggleAddon(checkbox, eventTarget) {
      if (eventTarget.hasAttribute('data-usage-popup-trigger')) { return; }

      const parentWrapper = checkbox.closest('[data-configurator-addon-product]');
      const button = parentWrapper.querySelector('button');
      const select = parentWrapper.querySelector('select');

      parentWrapper.classList.toggle('disabled', !checkbox.checked);

      if (checkbox.checked) {
        if (button) {
          button.removeAttribute('tabindex');
        }

        if (select) {
          select.removeAttribute('tabindex');
        }
      } else {
        if (button) {
          button.setAttribute('tabindex', '-1');
        }

        if (select) {
          select.setAttribute('tabindex', '-1');
        }
      }

      this.updateAddonState();
      this.buildSummary();
    }

    /**
     * Update the variants displayed in the addon selects depending on the selected supply duration
     */
    updateAddonSelects() {
      this.addonVariantSelects.forEach((select) => {
        const selectedTitle = select.options[select.selectedIndex]?.getAttribute("data-title");
        const selectVariantMap = JSON.parse(select.getAttribute('data-variant-map'));
        const matchingVariants = selectVariantMap.filter((variant) => variant.title.indexOf(this.state.supplyDuration) >= 0 && variant.exclude === false)

        select.innerHTML = matchingVariants.map((variant) => {
          const variantTitle = variant.title.split('/').slice(1).join('/');
          if(variantTitle == selectedTitle)
          {
            return `
              <option value="${variant.id}" selected data-variant-price="${variant.price}" data-title="${variant.title.split('/').slice(1).join('/')}">
                ${variant.title.split('/').slice(1).join('/')}
              </option>
            `
          }
          else
          {
            return `
              <option value="${variant.id}" data-variant-price="${variant.price}" data-title="${variant.title.split('/').slice(1).join('/')}">
                ${variant.title.split('/').slice(1).join('/')}
              </option>
            `
          }

        });

        select.closest('[data-configurator-addon-product]')?.classList.toggle('single-variant', matchingVariants.length === 1)

        if (!select.hasAttribute('[tabindex="-1"]')) {
          select.dispatchEvent(new Event('change'));
        }
      });
    }

    /**
     * Update the variants displayed in the mandatory addon selects depending on the selected supply duration
     */
    updateMandatoryAddonSelects() {
      this.mandatoryAddonSelects.forEach((select) => {
        const originalSelectOptionText = select.options[select.selectedIndex].innerText.trim();
        const selectVariantMap = JSON.parse(select.getAttribute('data-variant-map'))
        const matchingVariants = selectVariantMap.filter((variant) => variant.title.indexOf(this.state.supplyDuration) >= 0 && variant.exclude === false)

        select.innerHTML = `
          <option value="" selected disabled>
            ${select.getAttribute('data-configurator-mandatory-addon-select')}
          </option>
        `

        select.innerHTML += matchingVariants.map((variant) => {
          return `
            <option value="${variant.id}" data-variant-price="${variant.price}" ${variant.title.split(' / ')[1] === originalSelectOptionText ? 'selected': ''}>
              ${variant.title.split(' / ')[1]}
            </option>
          `
        })
      })
    }

    /**
     * Update addon product array with the selected addon products
     */
    updateAddonState() {
      const selectedAddons = Array.from(this.addonVariantSelects).filter((select) => !select.hasAttribute('tabindex'));
      const selectedMandatoryAddons = Array.from(this.mandatoryAddonSelects).filter((select) => !select.hasAttribute('tabindex'));
      const selects = selectedAddons.concat(selectedMandatoryAddons);

      this.state.addonProducts = selects.filter((select) => select.value !== '').map((addonSelect) => {
        return {
          title: addonSelect.getAttribute('data-product-title'),
          handle: addonSelect.getAttribute('data-product-handle'),
          url: addonSelect.getAttribute('data-product-url'),
          price: addonSelect.options[addonSelect.selectedIndex]?.getAttribute('data-variant-price'),
          productId: parseInt(addonSelect.getAttribute('data-product-id')),
          variantId: parseInt(addonSelect.value),
          variantTitle: addonSelect.options[addonSelect.selectedIndex]?.text,
          quantity: 1
        }
      });

      this.buildSummary();
    }

    /**
     * Update binder and retail product arrays with the selected products
     * @param {Element} input - The input that gets changed
     */
    updateProductState(input) {
      const inputType = input.getAttribute('data-type');
      const selectedInputs = Array.from(this.quantityInputs).filter((input) => input.value >= 1 && input.getAttribute('data-type') === inputType);
      const selectedProductsData = selectedInputs.map((input) => {
        return {
          title: input.getAttribute('data-product-title'),
          handle: input.getAttribute('data-product-handle'),
          url: input.getAttribute('data-product-url'),
          price: input.getAttribute('data-product-price'),
          productId: parseInt(input.getAttribute('data-product-id')),
          variantId: parseInt(input.getAttribute('data-variant-id')),
          quantity: parseInt(input.value)
        }
      })

      if (inputType === 'binder') {
        this.state.binderProducts = selectedProductsData;
      } else {
        this.state.retailProducts = selectedProductsData;
      }

      this.buildSummary();
    }

    /**
     * Enable the selects in the type step depending on if the this.state.type is Powder
     */
    updateTypeSelects() {
      const typeSelects = this.querySelectorAll('[data-configurator-type-select]');

      typeSelects.forEach((typeSelect) => {
        const buttons = typeSelect.querySelectorAll('button');
        const selects = typeSelect.querySelectorAll('select');

        if (this.state.type && this.state.type.indexOf('Powder') >= 0) {
          typeSelect.classList.remove('disabled');
          buttons.forEach((button) => button.removeAttribute('tabindex'));
          selects.forEach((select) => select.removeAttribute('tabindex'));
        } else {
          typeSelect.classList.add('disabled');
          buttons.forEach((button) => button.setAttribute('tabindex', '-1'));
          selects.forEach((select) => select.setAttribute('tabindex', '-1'));
        }
      });
    }

    /**
     * Update the variant prices displayed in the type step based on the selected option in the duration step
     */
    updateMainProductPricing() {
      const matchingVariants = this.productData.variants.filter((variant) => variant.title.indexOf(this.state.supplyDuration) >= 0);
      const variantPrices = this.querySelectorAll('[data-configurator-variant-price]');

      variantPrices.forEach((variantPrice) => {
        const variantTitle = variantPrice.getAttribute('data-variant-title').split('/')[1];
        const matchingVariant = matchingVariants.find((variant) => variant.title.split('/')[1] === variantTitle);
        if (!matchingVariant) { return; }
        variantPrice.innerText = Shopify.formatMoney(matchingVariant.price, window.themeVariables.settings.moneyFormat);
      });
    }

    /**
     * Update the main product id and variant id state
     */
    updateMainProductIds() {
      let matchingVariant = null;

      if (this.state.neutralizer) {
        matchingVariant = this.productData.variants.find((variant) => variant.title.indexOf(this.state.supplyDuration) >= 0 && variant.title.indexOf(this.state.neutralizer) >= 0);
      } else {
        matchingVariant = this.productData.variants.find((variant) => variant.title.indexOf(this.state.supplyDuration) >= 0);
      }

      this.state.mainProduct.variantId = matchingVariant.id;
      this.state.mainProduct.title = matchingVariant.title;
      this.state.mainProduct.sku = matchingVariant.sku;
      this.state.mainProduct.id = this.productData.id;
      this.state.mainProduct.handle = this.productData.handle;
    }

    /**
     * Update displayed neutralizer info depending on the selected neutralizer option
     */
    updateNeutralizerInfo() {
      if (this.neutralizerSelect.value === '') { return; }

      const neutralizerInfoElements = this.querySelectorAll('[data-configurator-neutralizer-info]');

      neutralizerInfoElements.forEach((neutralizerInfoElement) => {
        const variantTitle = neutralizerInfoElement.getAttribute('data-variant-title');
        neutralizerInfoElement.classList.toggle('hidden', this.neutralizerSelect.value.indexOf(variantTitle) === -1);
      });

      if (this.state.type && this.state.type.indexOf('Powder') >= 0) {
        this.state.neutralizer = this.neutralizerSelect.value;
      } else {
        this.state.neutralizer = null;
      }

      this.updateMainProductIds();
      this.buildSummary();
      this.typeStepValidation();
    }

    /**
     * Update complimentary flavour info based on the selected complimentary flavour option
     */
    updateComplimentaryFlavourInfo() {
      if (this.complimentaryFlavourSelect.value === '') { return; }

      const flavourInfoElements = this.querySelectorAll('[data-configurator-complimentary-flavour-info]');

      flavourInfoElements.forEach((flavourInfoElement) => {
        const variantId = flavourInfoElement.getAttribute('data-variant-id');
        flavourInfoElement.classList.toggle('hidden', this.complimentaryFlavourSelect.value.indexOf(variantId) === -1);
      });

      if (this.state.type && this.state.type.indexOf('Powder') >= 0 && this.complimentaryFlavourSelect.value !== 'no-flavour') {
        this.state.flavourProduct.title = this.complimentaryFlavourSelect.options[this.complimentaryFlavourSelect.selectedIndex].text;
        this.state.flavourProduct.id = parseInt(this.complimentaryFlavourSelect.options[this.complimentaryFlavourSelect.selectedIndex].getAttribute('data-product-id'));
        this.state.flavourProduct.variantId = parseInt(this.complimentaryFlavourSelect.value);
        this.state.flavourProduct.url = this.complimentaryFlavourSelect.options[this.complimentaryFlavourSelect.selectedIndex].getAttribute('data-product-url');
        this.state.flavourProduct.handle = this.complimentaryFlavourSelect.options[this.complimentaryFlavourSelect.selectedIndex].getAttribute('data-product-handle');
        this.state.flavourProduct.selected = true
      } else {
        this.state.flavourProduct.selected = this.complimentaryFlavourSelect.value === 'no-flavour'
        this.state.flavourProduct.title = null;
        this.state.flavourProduct.id = null;
        this.state.flavourProduct.variantId = null;
        this.state.flavourProduct.url = null;
        this.state.flavourProduct.handle = null;
      }

      this.buildSummary();
      this.typeStepValidation();
    }

    /**
     * Update mandatory product info based on the selected mandatory product option
     * @param {Element} select - The select element that is changing
     */
    updateMandatoryAddonInfo(select) {
      if (select.value === '') { return; }

      const addonInfoElements = this.querySelectorAll('[data-configurator-mandatory-addon-info]');

      addonInfoElements.forEach((addonInfoElement) => {
        const variantId = addonInfoElement.getAttribute('data-variant-id');
        addonInfoElement.classList.toggle('hidden', select.value.indexOf(variantId) === -1);
      });

      this.updateAddonState();
      this.typeStepValidation();
    }

    /**
     * Update atc button state based on confirmation checkbox
     */
    toggleConfirmation() {
      this.state.confirmation = this.confirmation.checked;

      const lengthValidation = this.labelNameInput.value.trim().length > 1;

      if (lengthValidation && this.clientNameSelect.value && this.state.consultation != '') {
        this.primarySaveProtocolButton.toggleAttribute('disabled', !this.state.confirmation);
      } else {
        this.primarySaveProtocolButton.setAttribute('disabled', true);
      }
    }

    /**
     * Switch between steps
     * @param {Number} targetStep - Target step number that the UI should navigate to
     */
    switchSteps(targetStep) {
      const stepsWrapper = this.querySelector('[data-configurator-steps-wrapper]');

      this.saveProtocolButtons.forEach((button) => button.classList.toggle('hidden', this.steps.length !== parseInt(targetStep)));

      if (!this.state.type) {
        this.typeOptions.forEach((option) => {
          if (option.getAttribute('data-value').indexOf('Powder') === -1) { return; }
          option.click();
        });
      }

      this.summaries.forEach((summary) => {
        if (!summary.hasAttribute('data-sidebar')) { return; }
        summary.classList.toggle('hidden', this.steps.length === parseInt(targetStep));
        stepsWrapper.classList.toggle('configurator__steps--full', this.steps.length === parseInt(targetStep));
      });

      this.steps.forEach((stepElement) => {
        if (parseInt(stepElement.getAttribute('data-step')) === parseInt(targetStep)) {
          stepElement.classList.remove('hidden');
        } else {
          stepElement.classList.add('hidden');
        }
      });

      this.navLinks.forEach((navLink) => {
        if (!navLink.classList.contains('active') || targetStep < parseInt(navLink.getAttribute('data-step'))) { return; }
        navLink.classList.add('completed');
      });

      this.navLinks.forEach((navLink) => {
        if (navLink.getAttribute('data-step') === targetStep) {
          navLink.classList.add('active');
          navLink.classList.remove('disabled');
        } else {
          navLink.classList.remove('active');
        }
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    /**
     * Build the configurator summary with all of the current data in this.state
     */
    buildSummary() {
      this.summaries.forEach((summary) => {
        const supplyDuration = summary.querySelector('[data-configurator-summary-supply-duration]');
        const typeWrapper = summary.querySelector('[data-configurator-summary-type-wrapper]');
        const type = summary.querySelector('[data-configurator-summary-type]');
        const price = summary.querySelector('[data-configurator-summary-price]');
        const neutralizerWrapper = summary.querySelector('[data-configurator-summary-neutralizer-wrapper]');
        const neutralizer = summary.querySelector('[data-configurator-summary-neutralizer]');
        const additionalProductsWrapper = summary.querySelector('[data-configurator-summary-additional-products-wrapper]');
        const addonWrapper = summary.querySelector('[data-configurator-summary-addon-wrapper]');
        const addonList = summary.querySelector('[data-configurator-summary-addon-list]');
        const flavourWrapper = summary.querySelector('[data-configurator-summary-flavour-wrapper]');
        const flavour = summary.querySelector('[data-configurator-summary-flavour]');
        const binderList = summary.querySelector('[data-configurator-summary-binder-list]');
        const retailList = summary.querySelector('[data-configurator-summary-retail-list]');
        const protocolWrapper = summary.querySelector('[data-configurator-summary-protocol-wrapper]');
        const protocolTotal = summary.querySelector('[data-configurator-summary-protocol-total]');

        supplyDuration.innerText = this.state.supplyDuration;
        type.innerText = this.state.type;
        price.innerText = this.state.price;
        typeWrapper.classList.toggle('hidden', !this.state.type);
        neutralizer.innerText = this.state.neutralizer;
        neutralizerWrapper.classList.toggle('hidden', !this.state.neutralizer);
        addonWrapper.classList.toggle('hidden', this.state.addonProducts.length === 0);
        flavourWrapper.classList.toggle('hidden', !this.state.flavourProduct.title);
        flavour.innerText = this.state.flavourProduct.title;
        additionalProductsWrapper.classList.toggle('hidden', !this.state.flavourProduct.title && this.state.binderProducts.length === 0 && this.state.retailProducts.length === 0);
        protocolWrapper.classList.toggle('hidden', !this.state.mainProduct.variantId);

        addonList.innerHTML = this.state.addonProducts.map((addon) => {
          return `
            <li>
              <span class="flex justify-between">
                <span>${addon.title}${addon.variantTitle ? ` - ${addon.variantTitle}` : ''}</span>
                <span data-configurator-summary-formula-price>${addon.price}</span>
              </span>
            </li>
          `
        }).reverse().join('');

        binderList.innerHTML = this.state.binderProducts.map((product) => {
          return `
            <li>
              <span class="flex justify-between">
                <span>${product.quantity >= 2 ? `${product.quantity}x ` : ''}${product.title}</span>
                <span data-configurator-summary-formula-price>$${(parseFloat(product.price.replace('$', ''), 10)) * parseInt(product.quantity)}</span>
              </span>
            </li>
          `
        }).join('');

        retailList.innerHTML = this.state.retailProducts.map((product) => {
          return `
            <li>
              <span class="flex justify-between">
                <span>${product.quantity >= 2 ? `${product.quantity}x ` : ''}${product.title}</span>
                <span data-configurator-summary-retail-price>$${(parseFloat(product.price.replace('$', ''), 10)) * parseInt(product.quantity)}</span>
              </span>
            </li>
          `
        }).join('');

        // Set protocol total
        let protocolValue = 0;
        const formulaPrices = summary.querySelectorAll('[data-configurator-summary-formula-price]');
        const retailPrices = summary.querySelectorAll('[data-configurator-summary-retail-price]');
        formulaPrices.forEach((price) => protocolValue += parseFloat(price.innerText.replace('$', ''), 10));
        retailPrices.forEach((price) => protocolValue += parseFloat(price.innerText.replace('$', ''), 10));
        protocolTotal.innerText = `$${protocolValue.toFixed(2)}`;
      });
    }

    /**
     * Initialize Wishlist Plus
     */
    wishlistPlusInit() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(onSwymLoadCallback);

      /**
       * Wishlist Plus Callbacks
       */
      function onSwymLoadCallback(swat) {
        if (swat) {
          document.addEventListener('saveConfigurator', (event) => createList(swat, event.detail.listName, event.detail.labelName, event.detail.clientName, event.detail.allergyInformation, event.detail.consultation, event.detail.emailAddress, event.detail.products));

          if (window.location.href.indexOf('edit_lid') >= 0) {
            const urlParams = new URLSearchParams(window.location.search);
            const lid = urlParams.get('edit_lid');
            fetchList(swat, lid);
          }
        } else {
          window.location.reload();
        }
      }

      /**
       * Create Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} listName - Name for the list
       * @param {String} labelName - Name for the label
       * @param {String} clientName - Client name, will get added as an lprop on the list
       * @param {String} allergyInformation - Allergy information, will get added as an lprop on the list
       * @param {String} emailAddress - Email address, will get added as an lprop on the list
       * @param {Array} products - List of products to add to list
       */
      function createList(swat, listName, labelName, clientName, allergyInformation, consultation, emailAddress, products) {
        const listConfig = {
          lname: listName,
          lprops: {
            'Label Name': labelName ? labelName : '',
            'Client Name': clientName ? clientName : '',
            'Allergy Information': allergyInformation ? allergyInformation : '',
            'Consultation': consultation,
            'Email Address': emailAddress ? emailAddress : '',
            'Base Ingredients': document.querySelector('.ingredients-dropdown-list').innerHTML
          }
        }

        const fetchListsOnSuccess = function(lists) {
          const matchingList = lists.find((list) => list.lname === listName);

          if (matchingList) {
            swat.deleteList(matchingList.lid, deleteListOnSuccess, deleteListOnError);
          } else {
            swat.createList(listConfig, createListOnSuccess, createListOnError);
          }
        }

        const fetchListsOnError = function(error) {
          console.log('Error while fetching all Lists', error);
          resetSavePopup();
        }

        const createListOnSuccess = function(newList) {
          addProductsToList(swat, newList.lid, products);
        }

        const createListOnError = function(error) {
          console.log('Error while creating a List', error);
          resetSavePopup();
        }

        const deleteListOnSuccess = function(deletedList) {
          swat.createList(listConfig, createListOnSuccess, createListOnError);
        }

        const deleteListOnError = function(error) {
          console.log('Error while deleting a List', error);
          resetSavePopup();
        }

        function resetSavePopup() {
          const savePopupHeading = document.querySelector('[data-configurator-save-popup-heading]');
          const savePopupLoading = document.querySelector('[data-configurator-save-popup-loading]');
          const savePopupStep1 = document.querySelector('[data-configurator-save-popup-step-1]');

          savePopupHeading.classList.remove('hidden');
          savePopupStep1.classList.remove('hidden');
          savePopupLoading.classList.add('hidden');
          savePopupHeading.innerText = savePopupHeading.getAttribute('data-original-text');

          alert('Error while saivng protocol, please try again');
        }

        swat.fetchLists({
          callbackFn: fetchListsOnSuccess,
          errorFn: fetchListsOnError
        });
      }

      /**
       * Add products to Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} lid - List ID that the products should be added to
       * @param {Array} products - List of products to add to the list
       */
      function addProductsToList(swat, lid, products) {
        const productBatches = []
        for (let i = 0; i < products.length; i += 10) {
          productBatches.push(products.slice(i, i + 10))
        }

        let currentBatchIndex = 0

        const processNextBatch = () => {
          if (currentBatchIndex >= productBatches.length) {
            const savePopupHeading = document.querySelector('[data-configurator-save-popup-heading]')
            const savePopupLoading = document.querySelector('[data-configurator-save-popup-loading]')
            const savePopupStep2 = document.querySelector('[data-configurator-save-popup-step-2]')

            savePopupHeading.classList.remove('hidden')
            savePopupLoading.classList.add('hidden')
            savePopupStep2.classList.remove('hidden')

            return
          }

          const currentBatch = productBatches[currentBatchIndex];
          swat.addProductsToList(
            lid,
            currentBatch,
            () => {
              currentBatchIndex++
              processNextBatch()
            },
            (error) => {
              console.error('Error while adding batch of products to the list', error)
            }
          )
        }

        processNextBatch()
      }

      /**
       * Get list by id from Wishlist Plus API
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} lid - List ID that the products should be added to
       * @param {Array} products - List of products to add to the list
       */
      function fetchList(swat, lid) {
        let listConfig = {
          lid
        };

        let onSuccess = function(listDetails) {
          document.dispatchEvent(new CustomEvent('buildFromEditLink', { detail: listDetails }));
        }

        let onError = function(error) {
          console.log('Error while fetching List details', error);
        }

        swat.fetchListDetails(listConfig, onSuccess, onError);
      }
    }

    /**
     * Build using saved list returned from Wishlist Plus API
     */
    buildFromEditLink(list) {
      if (!list) { return; }

      const mainProduct = list.items?.find((item) => item.cprops.type === 'main');
      const flavourProduct = list.items?.find((item) => item.cprops.type === 'flavour');
      const addonProducts = list.items?.filter((item) => item.cprops.type === 'addon');
      const binderProducts = list.items?.filter((item) => item.cprops.type === 'binder');
      const retailProducts = list.items?.filter((item) => item.cprops.type === 'retail');

      if (mainProduct) {
        const option1Title = mainProduct.vi.split('/')[0];
        const option2Title = mainProduct.vi.split('/')[1];
        const matchingSupplyDurationOption = Array.from(this.supplyDurationOptions).find((option) => option.getAttribute('data-value').indexOf(option1Title) >= 0);
        const matchingTypeOption = Array.from(this.typeOptions).find((option) => option.getAttribute('data-value').indexOf(option2Title.split(' - ')[0]) >= 0);

        if (matchingSupplyDurationOption) {
          matchingSupplyDurationOption.click();
        }

        if (matchingTypeOption) {
          matchingTypeOption.click();
        }

        if (option2Title && option2Title.indexOf('Powder') >= 0) {
          for (let index = 0; index < this.neutralizerSelect.length; index++) {
            if (this.neutralizerSelect.options[index].value === option2Title) {
              this.neutralizerSelect.value = option2Title;
              this.neutralizerSelect.dispatchEvent(new Event('change'));
            }
          }
        }
      }

      const flavourProductId = (flavourProduct) ? flavourProduct.epi : 'no-flavour';

      for (let index = 0; index < this.complimentaryFlavourSelect.length; index++) {
        if (this.complimentaryFlavourSelect.options[index].value == flavourProductId) {
          this.complimentaryFlavourSelect.value = flavourProductId;
          this.complimentaryFlavourSelect.dispatchEvent(new Event('change'));
        }
      }

      addonProducts.forEach((product) => {
        const matchingAddonCheckbox = Array.from(this.addonProductCheckboxes).find((checkbox) => checkbox.value == product.empi);
        const matchingMandatoryAddonSelect = Array.from(this.mandatoryAddonSelects).find((select) => select.getAttribute('data-product-id') == product.empi);

        if (matchingAddonCheckbox && !matchingAddonCheckbox.closest('.soldout')) {
          matchingAddonCheckbox.click();

          const matchingAddonSelect = matchingAddonCheckbox.closest('[data-configurator-addon-product]')?.querySelector('[data-configurator-addon-select]');

          if (matchingAddonSelect) {
            let hasMatchingOption = false;

            for (let index = 0; index < matchingAddonSelect.length; index++) {
              if (parseInt(matchingAddonSelect.options[index].value) === product.epi) {
                matchingAddonSelect.value = product.epi;
                matchingAddonSelect.dispatchEvent(new Event('change'));
                hasMatchingOption = true;
              }
            }

            if (hasMatchingOption === false) {
              matchingAddonCheckbox.click();
            }
          }
        }

        if (matchingMandatoryAddonSelect) {
          matchingMandatoryAddonSelect.value = product.epi;
          matchingMandatoryAddonSelect.dispatchEvent(new Event('change'));
        }
      });

      binderProducts.forEach((product) => {
        const binderQuantityInputs =  Array.from(this.quantityInputs).filter((input) => input.getAttribute('data-type') === 'binder');
        const matchingBinderQuantityInput = binderQuantityInputs.find((input) => input.getAttribute('data-variant-id') == product.epi);

        if (matchingBinderQuantityInput && !matchingBinderQuantityInput.closest('.soldout')) {
          matchingBinderQuantityInput.value = product.qty;
          matchingBinderQuantityInput.dispatchEvent(new Event('change'));
        }
      });

      retailProducts.forEach((product) => {
        const retailQuantityInputs =  Array.from(this.quantityInputs).filter((input) => input.getAttribute('data-type') === 'retail_products');
        const matchingRetailQuantityInput = retailQuantityInputs.find((input) => input.getAttribute('data-variant-id') == product.epi);

        if (matchingRetailQuantityInput && !matchingRetailQuantityInput.closest('.soldout')) {
          matchingRetailQuantityInput.value = product.qty;
          matchingRetailQuantityInput.dispatchEvent(new Event('change'));
        }
      });

      if (list.list.lprops['Label Name']) {
        this.summaryImageText.innerText = list.list.lprops['Label Name'];
        this.labelNameInput.value = list.list.lprops['Label Name'];
        this.labelNameInput.dispatchEvent(new Event('keyup'));
      }

      if (list.list.lprops['Client Name']) {
        this.clientNameSelect.value = list.list.lprops['Client Name'];
        this.clientNameSelect.dispatchEvent(new Event('change'));
      }

      if (list.list.lprops['Allergy Information']) {
        this.allergyInformationTextarea.value = list.list.lprops['Allergy Information'];
        this.allergyInformationTextarea.dispatchEvent(new Event('change'));
      }

      this.navLinks.forEach((navLink) => {
        navLink.classList.add('completed');
        navLink.classList.remove('disabled');
      });

      this.state.listName = list.list.lname;

      if (this.clientNameSelect.value !== '') {
        this.clientNameSelect.setAttribute('disabled', true);
      }

      this.switchSteps(this.steps.length);
      setTimeout(() => this.buildSummary(), 100);
    }

    /**
     * Update save popup input value if there is already a listName in the state
     */
    updateSavePopupInput() {
      const savePopupNameInput = document.querySelector('[data-configurator-save-popup-name-input]');
      if (!savePopupNameInput || !this.state.listName) { return; }
      savePopupNameInput.value = this.state.listName;
    }

    /**
     * Pass formatted data from this.state to Wishlist Plus to create and save a new list
     */
    saveProtocol() {
      const savePopupHeading = document.querySelector('[data-configurator-save-popup-heading]');
      const savePopupNameInput = document.querySelector('[data-configurator-save-popup-name-input]');
      const savePopupLoading = document.querySelector('[data-configurator-save-popup-loading]');
      const savePopupStep1 = document.querySelector('[data-configurator-save-popup-step-1]');

      if (savePopupNameInput.value === '' || savePopupNameInput.value.length < 3) { return; }

      const pattern =/[^a-zA-Z0-9\_\!\&\$\#\@\ \,\'\’\.\-]+/;

      if (pattern.test(savePopupNameInput.value)) {
        alert(window.themeVariables.strings.configuratorSaveError.replace('&amp;', '&').replace('&#39;', '’'));
        return;
      }

      savePopupHeading.classList.add('hidden');
      savePopupStep1.classList.add('hidden');
      savePopupLoading.classList.remove('hidden');
      savePopupHeading.innerText = savePopupHeading.getAttribute('data-success-text');
      this.state.listName = savePopupNameInput.value;

      const mainProduct = [{
        du: window.location.href.split('?')[0],
        empi: this.state.mainProduct.id,
        epi: this.state.mainProduct.variantId,
        qty: 1,
        cprops: {
          type: 'main'
        }
      }];

      const flavourProduct = [];

      if (this.state.flavourProduct.url) {
        flavourProduct.push({
          du: this.state.flavourProduct.url,
          empi: this.state.flavourProduct.id,
          epi: this.state.flavourProduct.variantId,
          qty: 1,
          cprops: {
            type: 'flavour'
          }
        })
      }

      const addonProducts = this.formatArrayForWishlistPlusApi(this.state.addonProducts, 'addon');
      const binderProducts = this.formatArrayForWishlistPlusApi(this.state.binderProducts, 'binder');
      const retailProducts = this.formatArrayForWishlistPlusApi(this.state.retailProducts, 'retail');
      const products = mainProduct.concat(flavourProduct, addonProducts, binderProducts, retailProducts);

      const detail = {
        listName: this.state.listName,
        labelName: this.state.labelName,
        clientName: this.state.clientName ? this.state.clientName : this.clientNameSelect.value,
        allergyInformation: this.state.allergyInformation,
        consultation:this.state.consultation,
        emailAddress: this.state.emailAddress ? this.state.emailAddress : this.clientNameSelect.options[this.clientNameSelect.selectedIndex].getAttribute('data-email-address'),
        products
      }

      document.dispatchEvent(new CustomEvent('saveConfigurator', { detail }));
    }

    /**
     * Format product data array for Wishlist Plus API
     * @param {Array} array - Array of products that is created through the stepper process. Ex. this.state.addonProducts
     * @param {String} type - Type that will be added to the product properties
     * @returns {Array} Array of formatted products suitable for the Wishlist Plus API
     */
    formatArrayForWishlistPlusApi(array, type) {
      const formattedArray = array.map((product) => {
        return {
          du: product.url,
          empi: product.productId,
          epi: product.variantId,
          qty: product.quantity,
          cprops: {
            type
          }
        }
      });

      return formattedArray;
    }

    /**
     * Add products to cart and set cart attributes
     */
    async addToCart() {
      const timestamp = Date.now();

      const mainProduct = [{
        title: this.state.mainProduct.title,
        id: this.state.mainProduct.variantId,
        quantity: 1,
        properties: {
          'Label Name': this.state.labelName ? this.state.labelName : '',
          'Client Name': this.state.clientName ? this.state.clientName : this.clientNameSelect.value,
          'Allergy Information': this.state.allergyInformation ? this.state.allergyInformation : '',
          'Consultation': this.state.consultation,
          '_type': 'main',
          '_protocol': timestamp,
          '_quantity': 1,
          '_handle': this.state.mainProduct.handle
        }
      }];

      let flavourProduct = [];

      if (this.state.flavourProduct.url) {
        flavourProduct = [{
          title: this.state.flavourProduct.title,
          id: this.state.flavourProduct.variantId,
          quantity: 1,
          properties: {
            '_type': 'flavour',
            '_protocol': timestamp,
            '_quantity': 1,
            '_handle': this.state.flavourProduct.handle
          }
        }];
      }

      const addonProducts = this.formatArrayForCartApi(this.state.addonProducts, 'addon', timestamp);
      const binderProducts = this.formatArrayForCartApi(this.state.binderProducts, 'binder', timestamp);
      const retailProducts = this.formatArrayForCartApi(this.state.retailProducts, 'retail', timestamp);
      const productsArray = mainProduct.concat(flavourProduct, addonProducts, binderProducts, retailProducts);

      const productData = productsArray.map((product) => {
        return {
          title: product.title,
          handle: product.properties._handle,
          variantId: product.id
        }
      });

      const formattedProductsArray = productsArray.map((product) => {
        delete product['title'];
        return product;
      });

      const soldoutItems = await window.checkInventoryLevels(productData, null);

      if (soldoutItems && soldoutItems.length) { return; }

      const postBody = {
        items: formattedProductsArray.reverse(),
        attributes: {
          'Client Name': this.state.clientName ? this.state.clientName : this.clientNameSelect.value,
          'Allergy Information': this.state.allergyInformation ? this.state.allergyInformation : '',
          'Email Address': this.state.emailAddress ? this.state.emailAddress : this.clientNameSelect.options[this.clientNameSelect.selectedIndex].getAttribute('data-email-address')
        }
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(postBody)
      })
      .then(response => {
        window.location.href = '/cart';
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    /**
     * Format product data array for Shopify Cart API
     * @param {Array} array - Array of products that is created through the stepper process. Ex. this.state.addonProducts
     * @param {String} type - Type that will be added to the product properties
     * @param {Number} timestamp - Timestamp that will be added to the product properties to tie it to a specific protocol
     * @returns {Array} Array of formatted products suitable for the Shopify Cart API
     */
    formatArrayForCartApi(array, type, timestamp) {
      const formattedArray = array.map((product) => {
        return {
          title: `${product.title}${product.variantTitle ? ` - ${product.variantTitle}` : ''}`,
          id: product.variantId,
          quantity: product.quantity,
          properties: {
            '_type': type,
            '_protocol': timestamp,
            '_quantity': product.quantity || 1,
            '_handle': product.handle
          }
        }
      });

      return formattedArray;
    }
  }

  window.addEventListener('load', () => {
    window.customElements.define('configurator-section', Configurator);
  });
}


if (!window.customElements.get('searchable-select')) {
  class SearchableSelect extends HTMLElement {
    constructor() {
      super();
      this.selectTrigger = this.querySelector("[data-trigger]");
      this.selectDropdown = this.querySelector("[data-dropdown]");
      this.selectDropdownOptions = this.querySelectorAll(".select-option");
      this.selectSearch = this.querySelector("[data-search]");
    }

    connectedCallback() {
      this.selectTrigger.addEventListener("click",()=>this.toggleSelectDropdown());

      this.selectDropdownOptions.forEach((option) => {
        option.addEventListener("click",()=>this.changeSelectBox(option));
      });

      this.selectSearch.addEventListener('keyup', () => this.searchItems());
    }

    toggleSelectDropdown(){
      const isShow = this.selectDropdown.classList.toggle("hidden");
      (!isShow)?this.selectSearch.focus():"";
    }

    changeSelectBox(option){
      this.removeSelected();
      const value = option.getAttribute("data-value");
      const label = option.innerHTML;
      option.classList.add("selected");
      this.selectTrigger.innerHTML = label;
      document.querySelector("[data-configurator-client-name]").value = value;
      document.querySelector("[data-configurator-client-name]").dispatchEvent(new Event('change'));
      this.toggleSelectDropdown();
    }

    removeSelected(){
      this.selectDropdownOptions.forEach((option) => {
        option.classList.remove("selected");
      });
    }

    searchItems() {
      // Accounting for dynamically created elements
      if (!this.selectDropdownOptions.length) {
        this.selectDropdownOptions = this.querySelectorAll(".select-option");;
      }

      if (this.selectSearch.value != '') {
        this.selectDropdownOptions.forEach((item) => {
          const searchAttribute = item.getAttribute('data-search-value').toLowerCase();
          item.classList.toggle('hidden', searchAttribute.indexOf(this.selectSearch.value.toLowerCase()) === -1);
        });
      } else {
        this.selectDropdownOptions.forEach((item) => item.classList.remove('hidden'));
      }
    }

  }

  window.customElements.define('searchable-select', SearchableSelect);
}


function generateProtocolSummary(){
  let summaryClientName = document.querySelector("#label-name").value;
  let summary = document.querySelector(".configurator__summary").innerHTML;
  const iframe = document.createElement('iframe');

  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(`
      <html>
      <head>
          <title>Print</title>
          <link href="//vykoncustoms.ca/cdn/shop/t/11/assets/saved-protocols.css?v=16836251928455084641762324402" rel="stylesheet" type="text/css" media="all">
          <style>
            @media print{
            [data-configurator-summary-supply-duration] + span,
            [data-configurator-summary-neutralizer] + span,
            [data-configurator-summary-formula-price],
            [data-configurator-summary-flavour] + span,
            [data-configurator-summary-retail-price]{
              display:none;
            }

            .configurator__step-heading{
              display:none;
            }
            .configurator__summary-protocol-total
            {
              display:none;
            } 
              
            hr
            {
              display:none;
            } 

            @page {
              size: auto;
              margin: 0mm;
            }
          }

          .configurator__step-heading{
            display:none;
          }
          .configurator__summary-protocol-total
          {
            display:none;
          }
          hr,.hidden
          {
            display:none;
          }
          ul{
            margin-left: 20px;
            padding-left: 0px;
          }
          
          ul li {
              margin-bottom: 10px;
          }
          
          [data-configurator-summary-additional-products-wrapper] ul {
              margin-left: 20px;
              padding-left: 0px;
              margin-top: 0px;
              margin-bottom: 0px !important;
          } 
          
          // [data-configurator-summary-additional-products-wrapper] ul:nth-child(2){
          //   margin-top: 16px;
          // }

          .configurator__summary-label {
              margin-bottom: 16px;
              display: block;
          }
            .ingredients-dropdown .ingredients-dropdown-list{
              display:block !important;
            }
            [data-configurator-summary-additional-products-wrapper] {
                margin-top: 20px !important;
            }
          </style>
      </head>
      <body>
        <div class="container" style="margin-left: 30px; font-family:Inter, sans-serif;  margin-right: 30px; padding-top:32px">
          <div class="saved-protocols__protocol">
          <h2 class="saved-protocols__protocol-title" style="font-size:40px;">${summaryClientName}</h2>
          <div class="saved-protocols__protocol-summary configurator__summary">${summary}</div>
          <div class="saved-protocols__print-dislcaimer" style="line-height: 25.6px;font-size:17px;font-weight:400">
            <small>
              Custom blends are only available for dispensing by certified health professionals, without warranty of any kind. Custom formulas have not been evaluated by the Food and Drug Administration or Health Canada. Our products are not intended to diagnose, treat, cure, or prevent any disease.  Vykon customized sales are final, no refund on Vykon customized products. 
            </small>
          </div>
          </div>
        </div>
      </body>
      </html>
  `);

  iframeDoc.close();
  iframe.contentWindow.print();
  document.body.removeChild(iframe);
}

function generateProtocolSummaryConfigurator(){
  const selector = document.querySelector(".configurator__step--summary");
  const lable = selector.querySelector("#label-name").value;
  const title = selector.querySelector(".configurator__summary-label").innerHTML;
  const allergy = "Allergy Information:"+selector.querySelector("#allergy-information").value;
  //const variant_selector = mainItem.querySelectorAll(".saved-protocol-list-item__variant li");
  const addon_selector = selector.querySelectorAll("[data-configurator-summary-addon-list] li");
  const flavour_selector = selector.querySelectorAll("[data-configurator-summary-flavour-wrapper] li");
  const binder_selector = selector.querySelectorAll("[data-configurator-summary-binder-list] li");
  const retail_selector = selector.querySelectorAll("[data-configurator-summary-retail-list] li");
  const sku = document.querySelector("configurator-section").state.mainProduct.sku;

  const ingredient_list = selector.querySelector(".ingredients-dropdown-list .metafield-rich_text_field ul").innerHTML;

  let variant_title = "";
  let addonList = '';
  let additionalItemList = '';

  variant_title = selector.querySelector("[data-configurator-summary-supply-duration]").innerHTML;

  const neutralizer_text = selector.querySelector("[data-configurator-summary-neutralizer]").innerHTML;
  if(neutralizer_text != "")
  {
    variant_title += " / "+selector.querySelector("[data-configurator-summary-neutralizer]").innerHTML;
  }
  else
  {
    variant_title += " / "+selector.querySelector("[data-configurator-summary-type]").innerHTML;
  }


  addon_selector.forEach((addon)=>{
    const addonItem = addon.querySelector("span span:nth-child(1)")?.innerHTML;
    if(addonItem != undefined && addonItem != '')
    {
      addonList += `<li class="addon-item">${addonItem}</li>`;
    }
  });

  flavour_selector.forEach((flavour)=>{
    const flavourItem = flavour.querySelector("span span:nth-child(1)")?.innerHTML;
    if(flavourItem != undefined && flavourItem != '')
    {
      additionalItemList += `<li class="addon-item">${flavourItem}</li>`;
    }
  });

  binder_selector.forEach((binder)=>{
    const binderItem = binder.querySelector("span span:nth-child(1)")?.innerHTML;
    if(binderItem != undefined && binderItem != '')
    {
      additionalItemList += `<li class="addon-item">${binderItem}</li>`;
    }
  });

  retail_selector.forEach((retail)=>{
    const retailItem = retail.querySelector("span span:nth-child(1)")?.innerHTML;
    if(retailItem != undefined && retailItem != '')
    {
      additionalItemList += `<li class="addon-item">${retailItem}</li>`;
    }
  });

  const protocolSummaryBody = `
      <div class="wrapper">
        <div class="header">
          <div class="shop-title">
            <p class="to-uppercase">
              VYKON CUSTOMS
            </p>
          </div>
        </div>
        <div class="hr"></div>
        <div class="order-container-header">
          <div class="order-container-header-sku">
            <p class="subtitle-bold to-uppercase">SKU</p>
          </div>
          <div class="order-container-header-left-content">
            <p class="subtitle-bold to-uppercase">Items</p>
          </div>
          <div class="order-container-header-right-content">
            <p class="subtitle-bold to-uppercase">Quantity</p>
          </div>
        </div>

      <div>

      <div class="flex-line-item">
        <div class="flex-line-item-sku">
          <p>
            ${sku}
          </p>
        </div>

        <div class="flex-line-item-description">
          <p>
            <p class="line-item-description-line">
              <strong>
                ${title}
              </strong>
            </p>
              <span class="line-item-description-line">
                ${variant_title}
              </span>
          </p>
            <p>
              Label Name: ${lable}
            </p>
            <br>

            <p>
              ${allergy}
            </p>
            <br>

            ${(ingredient_list != '')?
            `<div>
              <p>
                View Base Ingredients :
              </p>
              <div>
                <ul class="list-disc">
                  ${ingredient_list}
                </ul>
              </div>
            </div>
            <br>`:""}

            ${(addonList != '')?
              `
              <div>
                <p>
                  Addons:
                </p>

                <ul class="list-disc">
                  ${addonList}
                </ul>
              </div>
            `:""}
            ${(additionalItemList != '')?
              `
              <div>
                <p>
                  Additional Products:
                </p>

                <ul class="list-disc">
                  ${additionalItemList}
                </ul>
              </div>
            `:""}
        </div>
        <div class="flex-line-item-quantity">
          <p class="text-align-right">
            1 of 1
          </p>
        </div>
      </div>
      </div>
        <div class="hr"></div>
        <div class="footer">
          <p>
            <small>
              Custom blends are available exclusively for dispensing by certified healthcare professionals and are provided without any express or implied warranty. These custom formulations have not been evaluated by the U.S. Food and Drug Administration (FDA) or Health Canada. Our products are not intended to diagnose, treat, cure, or prevent any disease. All sales of Vykon customized products are final and are not eligible for refund or exchange. 
            </small>
          </p>
        </div>
      </div>
  `;

  generatePrint(protocolSummaryBody);


}

function openIngredientsDropdown(target){
  target.classList.toggle("acive");
}